const WORD_EXTENSIONS = new Set(['doc', 'docx', 'md', 'txt', 'rtf'])
const SHEET_EXTENSIONS = new Set(['csv', 'tsv', 'xls', 'xlsx'])
const IMAGE_EXTENSIONS = new Set(['gif', 'jpeg', 'jpg', 'png', 'webp'])
const PDF_EXTENSIONS = new Set(['pdf'])

export function documentCategoryFromName(fileName = '') {
  const extension = String(fileName).split('.').pop()?.toLowerCase() ?? ''
  if (SHEET_EXTENSIONS.has(extension)) return 'xls'
  if (IMAGE_EXTENSIONS.has(extension)) return 'images'
  if (PDF_EXTENSIONS.has(extension)) return 'document'
  if (WORD_EXTENSIONS.has(extension)) return 'docs'
  return 'docs'
}
